import React from 'react';
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from '@stripe/react-stripe-js';
import { twJoin } from 'tailwind-merge';
import FieldError from '../stepper/field-components/FieldError';
const elementWrapperStyle = 'border border-gray-opacity-15 rounded-5 py-3 px-4';

const STRIPE_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#262626',
      fontSize: '14px',
      fontFamily: '"proxima-nova", sans-serif',
      '::placeholder': {
        color: '#666',
      },
    },
    invalid: {
      color: '#262626',
      backgroundColor: '#FFF4C6',
    },
  },
};

interface AddCardFormProps {
  onElementChange: (
    name: string,
    error: Record<string, string> | undefined,
  ) => void;
  errors: Record<string, Record<string, string>>;
}

const AddCardForm: React.FC<AddCardFormProps> = ({
  onElementChange,
  errors,
}) => {
  return (
    <>
      <div>
        <label className="font-semibold text-neutral-800">
          <span>Card number</span>
          <span className="text-alert-negative">*</span>
        </label>
        <div
          className={twJoin(
            elementWrapperStyle,
            errors.cardNumber && 'border-alert-negative bg-error-yellow',
          )}
        >
          <CardNumberElement
            onChange={(e) => onElementChange('cardNumber', e.error)}
            options={STRIPE_ELEMENT_OPTIONS}
          />
        </div>
        {errors.cardNumber && (
          <FieldError className="mt-1">
            {errors?.cardNumber?.message}
          </FieldError>
        )}
      </div>

      <div className="flex w-full space-x-4">
        <div className="w-full">
          <label className="font-semibold text-neutral-800">
            <span>Expiration date</span>
            <span className="text-alert-negative">*</span>
          </label>
          <div
            className={twJoin(
              elementWrapperStyle,
              errors.cardExpiry && 'border-alert-negative bg-error-yellow',
            )}
          >
            <CardExpiryElement
              onChange={(e) => onElementChange('cardExpiry', e.error)}
              options={STRIPE_ELEMENT_OPTIONS}
            />
          </div>
          {errors.cardExpiry && (
            <FieldError className="mt-1">
              {errors?.cardExpiry?.message}
            </FieldError>
          )}
        </div>
        <div className="w-full">
          <label className="font-semibold text-neutral-800">
            <span>Security code</span>
            <span className="text-alert-negative">*</span>
          </label>
          <div
            className={twJoin(
              elementWrapperStyle,
              errors.cardCvc && 'border-alert-negative bg-error-yellow',
            )}
          >
            <CardCvcElement
              onChange={(e) => onElementChange('cardCvc', e.error)}
              options={STRIPE_ELEMENT_OPTIONS}
            />
          </div>
          {errors.cardCvc && (
            <FieldError className="mt-1">{errors?.cardCvc?.message}</FieldError>
          )}
        </div>
      </div>
    </>
  );
};

export default AddCardForm;
